import {
  RECIPE_UPLOAD_REQUEST,
  RECIPE_UPLOAD_SUCCESS,
  RECIPE_UPLOAD_FAIL,
  RECIPE_EDIT_REQUEST,
  RECIPE_EDIT_SUCCESS,
  RECIPE_EDIT_FAIL,
  RECIPE_DELETE_REQUEST,
  RECIPE_DELETE_SUCCESS,
  RECIPE_DELETE_FAIL
} from '../reducerConsts/recipesConsts';
import {
  GET_ADMIN_RECIPES_AND_VIDEOS_REQUEST,
  GET_ADMIN_RECIPES_AND_VIDEOS_SUCCESS,
  GET_ADMIN_RECIPES_AND_VIDEOS_FAIL,
  CLEAR_RECIPE_UPLOAD_STATE
} from '../reducerConsts/chefAdminConsts';

export const chefAdminRecipeReducer = (state = {}, action) => {
  
  switch(action.type){
    case RECIPE_UPLOAD_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case RECIPE_UPLOAD_SUCCESS: 
      return {
        ...state,
        isLoading: false,
        lastUploadedId: action.payload._id,
        successUpload: true,
        chefAdminRecipes: [
          ...state.chefAdminRecipes,
          action.payload
        ]
      }
    case RECIPE_UPLOAD_FAIL: 
      return {
        ...state,
        isLoading: false,
        successUpload: false,
        error: action.error
      };
    case CLEAR_RECIPE_UPLOAD_STATE:
      return {
        ...state,
        isLoading: false,
        successUpload: null,
        lastUploadedId: null
      }
    case RECIPE_EDIT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case RECIPE_EDIT_SUCCESS: 
      return {
        ...state,
        isLoading: false,
        chefAdminRecipes: state.chefAdminRecipes.map(recipe => 
          recipe._id === action.payload._id 
            ? action.payload 
            : recipe
        )
      }
    case RECIPE_EDIT_FAIL: 
      return {
        ...state,
        error: action.error
      };
    case RECIPE_DELETE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case RECIPE_DELETE_SUCCESS: 
      return {
        ...state,
        isLoading: false,
        chefAdminRecipes: state.chefAdminRecipes.filter(recipe => 
          recipe._id !== action.payload.recipeId
        )
      }
    case RECIPE_DELETE_FAIL: 
      return {
        ...state,
        error: action.error
      };
    case GET_ADMIN_RECIPES_AND_VIDEOS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_ADMIN_RECIPES_AND_VIDEOS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        chefAdminRecipes: action.payload.recipes
      };
    case GET_ADMIN_RECIPES_AND_VIDEOS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    default: return {
      ...state
    };
  };
};